import React, { useState, useEffect } from "react";
import '../CSS_stuff/events-format.css';

import img1 from '../assets/25-in-2025-poster.jpg';
import img2 from '../assets/2025-LaGrange.jpg';
// …import more images as needed

const upcomingImages = [

  // {
  //   src: img1,
  //   alt: "25-in-2025 at Witch's Brew KY: Join us celebrating Mangala McNamara’s 25th book and 52nd Birthday 5-7PM 8/20",
  //   link: 'https://example.com/witchs-brew-ky',
  //   name: "Celebrate the 25 novel pubished on Mangala McNamara's 52nd Birthday!",
  //   time: "August 20th, 5-7PM ",
  //   location: "Central Park, New York, NY1813 Frankfort Ave, Louisville, KY 40206"
  // }
  // …add more entries (each needs a link for the <a>)
];
// import your upcomingImages array here

export default function UpcomingEvents({ upcomingImages = [] }) {
  const [modalSrc, setModalSrc] = useState(null);

  // Close on ESC key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setModalSrc(null);
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  // Lock body scroll when modal opens
  useEffect(() => {
    document.body.style.overflow = modalSrc ? "hidden" : "auto";
  }, [modalSrc]);

  const openModal = (src) => setModalSrc(src);
  const closeModal = () => setModalSrc(null);

  const hasEvents = Array.isArray(upcomingImages) && upcomingImages.length > 0;

  return (
    <>
      <div className="events-container">
        {!hasEvents ? (
          <div className="no-events" role="status" aria-live="polite">
            No upcoming events planned
          </div>
        ) : (
          upcomingImages.map((img, idx) => (
            <div key={idx} className="event-item">
              <img
                src={img.src}
                alt={img.alt}
                className="event-image"
                onClick={() => openModal(img.src)}
              />

              <div className="event-info">
                <h4>{img.name}</h4>
                <p className="event-time">{img.time}</p>
                <p className="event-location">
                  <a
                    href={`https://maps.google.com?q=${encodeURIComponent(
                      img.location
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {img.location}
                  </a>
                </p>
              </div>
            </div>
          ))
        )}
      </div>

      {modalSrc && (
        <div
          className="modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={closeModal}
        >
          <button
            className="modal-close"
            aria-label="Close lightbox"
            onClick={closeModal}
          >
            ×
          </button>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={modalSrc} alt="" className="modal-image" />
          </div>
        </div>
      )}
    </>
  );
}